export default __webpack_public_path__ + "static/media/counter.a3d5c0a8.svg";